<script lang="ts">
    import {onMount} from "svelte";
    import {swClient} from "./../stores";

    /**Content of the library*/
    export let libraryContent : any[] = [];
    /**Type of image to load*/
    export let type : 'picto' | 'logo' = null;
    /**Function called when closing the modal */
    export let onClose;
    /**Is the modal init ?*/
    let isInit : boolean = false;
    /**Number of showed items*/
    let showedItems = 0;
    /**Liste of selected images*/
    let selectedImages : Array<{index : number, datafileUid : string, assetUid: string}> = [];
    
    let productsDiv;
    let last_scroll;
    let libraryShow;

    let searchValue = "";

    onMount( () => {
        for (let i = showedItems; i < showedItems + (libraryContent.length > 20 ? 20 : libraryContent.length); i++) {
                libraryContent[i].show = true;
            }
            showedItems = 20;
            libraryShow = libraryContent;
        isInit = true;
    })

    function wheelEvent(event) {
        if (event.deltaY > 0) {
            displayNextItems()
        }
	}

    function handleScroll() {
        if (productsDiv.scrollTop > last_scroll) {
            displayNextItems()
        }
        last_scroll = productsDiv.scrollTop;
    }

    function displayNextItems() {
        if (showedItems < libraryShow.length && libraryShow.length > 15) {
            libraryShow[showedItems].show = true;
            showedItems++;
        }
    }

    /**
     * Validate the selection
     */
    function validateLogo() {
        if (selectedImages && selectedImages.length > 0) {
            onClose(selectedImages);
            selectedImages = [];
            libraryShow.forEach(ls => {
                ls.selected = false;
            });
        }
    }

    /**
     * On image selection
     * @param contentAsset the content of the asset
     */
    function selectImage(contentAsset : any, index : number) {
        contentAsset.selected = !contentAsset.selected;
        if (contentAsset.selected) {
            // Add
            selectedImages.push({
                index,
                datafileUid : contentAsset.datafile_uid,
                assetUid : contentAsset.uid
            });
        } else {
            // suppr
            const indexToRemove = selectedImages.findIndex(img => {
                img.index === index;
            });
            if (indexToRemove !== -1) {
                selectedImages = selectedImages.splice(indexToRemove, 1);
            }
        }
        libraryShow = libraryShow;
    }

    function handleKeydown(event) {
        if (event.keyCode === 13) {
            search();
        }
    }

    function search() {
        showedItems = 0;
        const lowerCaseSearchValue = searchValue.toLowerCase();
        libraryShow.forEach(ls => {
            ls.show = false;
        });
        libraryShow = libraryContent.filter(lc => {
            if  (lc?.name?.toLowerCase().includes(lowerCaseSearchValue)) {
                if (showedItems < 20) {
                    lc.show = true;
                    showedItems++;
                }
                return true;
            } else {
                return false;
            }
        });
    }

</script>
<div id="modal">
    
    <div class="modal-header">
        <h3>Ajout de {type}</h3>
        <div id="search-desktop" class="field has-addons">
            <div id="input-control" class="control">
                <input class="input" type="text" placeholder="Rechercher une image" bind:value={searchValue} on:keydown={handleKeydown}>
            </div>
            <div class="control">
                <button class="button is-blue" on:click={search}>
                    <i class="fa fa-search"></i>
                </button>
            </div>
        </div>
    </div>
    <div class="modal-content">
        {#if isInit}
            <div bind:this={productsDiv} on:wheel={wheelEvent} on:scroll={handleScroll}>
                <div class="img-grid">
                    {#each libraryShow as content, i}
                        {#if content.show}
                            <div class="click-div {content.selected ? "selected" : ""}" on:click="{() => selectImage(content, i)}">
                                <img class="img" src={`${$swClient.uri}/v2/datafiles/${content.datafile_uid}`} alt="Preview" />
                                <!-- <label><input type="checkbox" bind:checked={content.selected} on:change="{() => selectImage(content, i)}"/></label> -->
                            </div>
                        {/if}
                    {/each}
                </div>
                <div style="max-height:200px; max-width:200px">
                </div>
            </div>
        {:else}
            <div class="flex">Chargement ...</div>
        {/if}
    </div>
    <div class="modal-footer">
        <div style="float: right;">
            <button class="button is-info" on:click="{() => validateLogo()}">Valider</button>
        </div>
    </div>
</div>


<style lang="scss">
    @import "../styles/variables.scss";
    .img-grid {
        width: 100%;
        min-height: 150px;
        min-width: 150px;
        display : grid;
        grid-template-columns: repeat(4, 1fr);
        .click-div {
            margin-top: 1px;
            margin-bottom: 1px;
            margin-left: 1px;
            margin-right: 1px;
            padding-left: 5px;
            padding-top: 5px;
            padding-right: 5px;
            padding-bottom: 5px;
            cursor: pointer;
            &:hover {
                background-color: $blue;
            }
        }
        .selected {
            background-color: $blue;
        }
    }
    .modal-header {
        padding-left: 10px;
        padding-top: 5px;
        padding-right: 10px;
        padding-bottom: 10px;
        margin-left: -1rem;
        margin-right: -1rem;
        border-bottom : solid $orange;
    }
    .modal-content {
        padding-left: 5px;
        padding-top: 5px;
        padding-right: 5px;
        padding-bottom: 5px;
        max-height: 43em;
        max-width: 39em;
    }
    .modal-footer {
        padding-left : 10px;
        padding-top: 10px;
        padding-right: 10px;
        padding-bottom: 5px;
        margin-left: -1rem;
        margin-right: -1rem;
        border-top : solid $orange;
    }
</style>
